export default Object.freeze({
    BASIC : 'basic',
    STABLE :'stable',
    MISSION_CRITICAL : 'mission_critical',
})
